import Footer from "../Footer";
import dynamic from "next/dynamic";
import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import Image from "next/future/image";
import ButtonArrow from "../reusable/ButtonArrow";
import { badgeMapper } from "../../utils/data";
import useScreenSize from "../../hooks/useScreenSize";
import FullScreenModal from "../reusable/FullScreenModal";
import CarouselContainer from "../reusable/CarouselContainer";
import Link from "next/link";
import { twMerge } from "tailwind-merge";
const BlogCardDesign3 = dynamic(() => import("../blog/BlogCardDesign3"), {
  ssr: false,
});

export default function Capabilities2({ dataList, bg, insights, hideFooter = false, hideCardSubtitle = false }) {
  const size = useScreenSize();
  const isSmall = size == "sm" || size == "md";

  const [selectedItem, setselectedItem] = useState("");
  const [currentBlog, setcurrentBlog] = useState({});
  const [modalConfig, setmodalConfig] = useState({
    open: false,
    children: <></>,
  });
  const isSmallRef = useRef(isSmall);

  useEffect(() => {
    isSmallRef.current = isSmall;
    if (!!size) {
      if (isSmall) {
        setselectedItem("");
      } else {
        setselectedItem(dataList[0]["key"]);
      }
    }
  }, [isSmall, size]);

  useEffect(() => {
    const contentIdx = dataList.findIndex(item => item.key === selectedItem);
    if (contentIdx != -1) {
      let selected = dataList[contentIdx];
      setcurrentBlog({ title: selected.title, subtitle: selected.text, img: selected.img });

      if (isSmallRef.current) {
        setmodalConfig({
          open: true,
          children: <CapabilityCard title={selected.title} subtitle={selected.text} />,
        });
      }
    }
  }, [selectedItem]);

  return (
    <>
      <section id="capabilities" className={`min-h-screen ${bg ? bg : "bg-slate-700"} flex flex-col pt-10 text-center   `}>
        <h2 className="text-white pt-3 pb-20 text-3xl text-left font-semibold w-[90%] mx-auto">Our Capabilities</h2>
        <div className="flex flex-wrap gap-4 justify-evenly mb-16">
          <div className="flex justify-between mt-2 w-[90%]  ">
            <div className="w-[100%] md:w-[50%] text-black cursor-pointer  ">
              {isSmall ? (
                <CarouselContainer>
                  {dataList.map(capability => {
                    return (
                      <div key={capability.key} className=" mb-6 py-4 px-4 w-[90%] mx-auto">
                        <CapabilityCard2
                          key={capability.key}
                          title={capability.key}
                          subtitle={capability.title}
                          img={capability.img}
                          onHoverStart={() => setselectedItem(capability.key)}
                          activeItem={selectedItem}
                          isSmall={isSmall}
                          hideSubtitle={hideCardSubtitle}
                        />
                      </div>
                    );
                  })}
                </CarouselContainer>
              ) : (
                dataList.map(capability => (
                  <CapabilityCard2
                    key={capability.key}
                    title={capability.key}
                    subtitle={capability.title}
                    img={capability.img}
                    onHoverStart={() => setselectedItem(capability.key)}
                    activeItem={selectedItem}
                    isSmall={isSmall}
                    hideSubtitle={hideCardSubtitle}
                  />
                ))
              )}
            </div>
            <div className="hidden md:block md:w-[45%] sticky top-[90px] self-start">
              <div>{selectedItem && currentBlog?.title ? <CapabilityCard title={currentBlog.title} subtitle={currentBlog.subtitle} inactiveColor="white" /> : <></>}</div>
            </div>
          </div>
        </div>

        <h2 className="text-white pt-3 pb-10 text-3xl text-left font-semibold w-[90%] mx-auto">Our Work</h2>

        {isSmall ? (
          <CarouselContainer>
            {insights.map(post => {
              return (
                <div key={post.meta.title} className="mb-6 py-4 px-4  w-[80%]  sm:w-[60%]  mx-auto">
                  <BlogCardDesign3
                    img={post.meta.img}
                    title={post.meta.title}
                    subheading={post.meta.subtitle}
                    slug={post.meta.slug}
                    badge={badgeMapper(post.meta.category)}
                  />
                </div>
              );
            })}
          </CarouselContainer>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mx-auto mb-2 w-[90%]">
            {insights.map(post => {
              return (
                <div key={post.meta.title} className="mb-6 py-4 px-4  mx-auto">
                  <BlogCardDesign3
                    img={post.meta.img}
                    title={post.meta.title}
                    subheading={post.meta.subtitle}
                    slug={post.meta.slug}
                    badge={badgeMapper(post.meta.category)}
                  />
                </div>
              );
            })}
          </div>
        )}

        <div className="w-[90%] flex flex-col md:flex-row mx-auto">
          <div className="w-full pt-[100px] pb-[30px] grid grid-cols-2 md:grid-cols-4 place-items-center">
            <ButtonArrow link="/capabilities" txt="Capabilities" style="text-sm md:text-lg  [&>div]:border-b-[0px] text-gray-200 hover:text-opacity-[0.8] " />
            <ButtonArrow
              link="/capabilities#Industry"
              txt="Industries"
              style="text-sm md:text-lg [&>div]:border-b-[0px] text-gray-200 hover:text-opacity-[0.8]"
            />
            <ButtonArrow
              link="/success-stories"
              txt="Success Stories"
              style="text-sm md:text-lg [&>div]:border-b-[0px] text-gray-200 hover:text-opacity-[0.8]"
            />
            <ButtonArrow link="/career" txt="Careers" style="text-sm md:text-lg [&>div]:border-b-[0px] text-gray-200 hover:text-opacity-[0.8]" />
          </div>
        </div>

        <div className="w-[90%] mx-auto mt-8">
          <div className="text-white md:p-3 md:mx-6 mt-20 mb-10 ">
            <p className="py-5 text-xl ">
              ITMTB helps companies build, operate, and improve business-critical technology systems through software engineering, cloud operations, cybersecurity, AI deployment, and managed services.
              <Link href="/contact-us">
                <a className="font-bold underline underline-offset-4 cursor-pointer mx-2">Let us talk</a>
              </Link>
              and explore how we can help.
              <br />
              <br />
            </p>
          </div>
        </div>
      </section>
      {!hideFooter && <Footer />}
      <FullScreenModal
        isOpen={modalConfig.open}
        onClose={() => {
          setmodalConfig(() => ({ open: false, children: <></> }));
          setselectedItem("");
        }}
      >
        {modalConfig.children}
      </FullScreenModal>
    </>
  );
}

export const CapabilityCard = ({ title, subtitle, img, activeItem, hideTitle = false, imgStyle, styleClass, knowMoreLink, inactiveColor = "grey" }) => {
  const isActive = activeItem === title;

  return (
    <motion.div
      key={title}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, color: isActive ? "white" : inactiveColor }}
      transition={{ duration: 0.7 }}
      style={{ color: inactiveColor }}
    >
      <div className={twMerge("flex flex-col items-start ", styleClass)}>
        {img ? (
          <div className="md:block mr-4 mb-4 mb:mb-0 flex-shrink-0 self-center w-[95%]  ">
            <Image
              src={img}
              className={twMerge("w-full h-auto md:h-[300px] mx-auto object-cover", imgStyle)}
              width="500"
              height="500"
              priority={true}
              alt={title}
              sizes="(max-width: 500px) 100vw, (max-width: 1200px) 70vw, 100vw"
              placeholder="blur"
              blurDataURL={img}
            />
          </div>
        ) : (
          <></>
        )}

        {!hideTitle ? <p className="text-xl md:text-3xl text-left font-semibold">{title}</p> : <></>}
        <p className="text-md md:text-[21px] leading-7  text-left mt-6 mb-4" dangerouslySetInnerHTML={{ __html: subtitle }} />
        {knowMoreLink ? (
          <Link href={knowMoreLink}>
            <div className="flex items-center text-lg gap-7 hover:opacity-[0.8] cursor-pointer">
              <b> Know more </b>
            </div>
          </Link>
        ) : (
          <></>
        )}
      </div>
    </motion.div>
  );
};

export const CapabilityCard2 = ({
  title,
  subtitle,
  onHoverStart,
  img,
  activeItem,
  isSmall,
  fadeTxtColor = "gray",
  imgStyle,
  styleClass,
  activeTxtColor = "white",
  hideBtn = false,
  hideSubtitle = false,
}) => {
  const isActive = activeItem === title;
  return (
    <motion.div
      transition={{ duration: 0.3 }}
      animate={isSmall ? {} : { x: isActive ? 30 : 0, color: isActive ? activeTxtColor : fadeTxtColor }}
      style={{ color: isSmall ? "#ffffff" : fadeTxtColor }}
      onHoverStart={!isSmall && onHoverStart}
      onClick={isSmall ? onHoverStart : () => {}}
      className={twMerge("flex flex-col md:flex-row text-white px-2 pb-2 mb-8 rounded", styleClass)}
    >
      {img ? (
        <div className=" md:block mr-4 flex-shrink-0 self-center ">
          <Image
            src={img}
            className={twMerge("w-[90vw] md:w-auto h-auto  md:h-[150px] mx-auto object-cover", imgStyle)}
            width="500"
            height="500"
            priority={true}
            alt={"how-digitisation-helps-formulation-companies"}
            sizes="(max-width: 500px) 100vw, (max-width: 1200px) 70vw, 100vw"
            placeholder="blur"
            blurDataURL={img}
          />
        </div>
      ) : (
        <></>
      )}
      <div className="text-left mt-5 md:mt-0 whitespace-pre-line">
        <h4 className="text-2xl md:text-2xl font-bold">{title}</h4>
        {!hideSubtitle && subtitle && <p className="mt-4 text-lg md:text-xl md:text-[21px] ">{subtitle}</p>}
      </div>
      {!hideBtn ? (
        <div className="block md:hidden mt-5 text-lg text-left">
          <p>
            View more{" "}
            <span aria-hidden="true" className="ml-2">
              &rarr;
            </span>
          </p>
        </div>
      ) : (
        <></>
      )}
    </motion.div>
  );
};